/**
 * MarkerSlot behavior — a spot where an image marker could sit
 *
 * Data-only and inert: no attach work, nothing rendered, no runtime reads it.
 * Editors read it from reference documents; the contract is on
 * {@link MarkerSlotData}.
 */

import { TraceBehavior } from "./tracebehavior";
import type { MarkerSlotData } from "../scenedata/behaviors/markerslotdata";

export class MarkerSlot extends TraceBehavior<MarkerSlotData> {
    static readonly behaviorType = "MarkerSlot" as const;
}
